var name = {};
module['exports'] = name;
name.last_name = require("./last_name");
name.first_name = require("./first_name");
name.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/name/index.js
// module id = 1304
// module chunks = 1